import {FC, ReactNode, useEffect, useState} from 'react';
import {Drawer as Vaul} from 'vaul';
import {SnapPoints, SnapType} from '~/QuickEcards/types/misc';

import './Drawer.sass';

interface DrawerProps {
  trigger: ReactNode;
  title: string;
  hiddenTitle?: boolean;
  content: ReactNode;
  // These 4 props allow for external state control
  isOpen?: boolean;
  toggleOpen?(state: boolean): void;
  snapPoints?: SnapType[];
  snapValue?: SnapType;
  updateSnapValue?(value: SnapType): void;
  overlay?: boolean;
  dismissable?: boolean;
}

export const Drawer: FC<DrawerProps> = ({
  trigger,
  title,
  hiddenTitle = false,
  content,
  // These 4 props allow for external state control
  isOpen = false,
  toggleOpen,
  snapPoints = SnapPoints,
  snapValue = snapPoints[0],
  updateSnapValue,
  overlay = true,
  dismissable = true,
}) => {
  const [open, setOpen] = useState(isOpen);
  const [snap, setSnap] = useState<SnapType>(snapValue);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  useEffect(() => {
    setSnap(snapValue);
  }, [snapValue]);

  return (
    <Vaul.Root
      snapPoints={snapPoints.filter(Boolean) as (string | number)[]}
      activeSnapPoint={snap}
      setActiveSnapPoint={updateSnapValue ?? setSnap}
      open={open}
      onOpenChange={toggleOpen ?? setOpen}
      modal={overlay}
      dismissible={dismissable}
      repositionInputs={false}
    >
      {/* Trigger */}
      <Vaul.Trigger asChild>{trigger}</Vaul.Trigger>

      {/* Content */}
      <Vaul.Portal>
        <Vaul.Overlay className="quick-ecards-drawer__overlay" />
        <Vaul.Content className="quick-ecards-drawer__content-wrapper" aria-describedby={undefined}>
          <Vaul.Title hidden={hiddenTitle}>{title}</Vaul.Title>
          <Vaul.Handle className="quick-ecards-drawer__handle" />
          <div className="quick-ecards-drawer__content">{content}</div>
        </Vaul.Content>
      </Vaul.Portal>
    </Vaul.Root>
  );
};
